import { RootState } from "app/store";
import { EControlType } from "components/ControlWrapper";
import { bcbs_config_attributeid_BCBSSCOtherSplit, bcbs_config_attributeid_BCCAdmin, bcbs_config_attributeid_BillGroup, bcbs_config_attributeid_FeeType, bcbs_config_attributeid_Guarantee, bcbs_config_attributeid_Onsite, bcbs_config_attributeid_ShowSeparateOnBill, friendlyValue, IFriendlyValueOptions } from "global/Application";
import { AppDataSource } from "global/DataSources/AppDataSource";
import { $att_$fees_and_premiums_$bcbs_attributeset_fee_id } from "model/ConfigAttributeConstants";
import { $oset_$fee_fee_type_id, $oset_$fee_split_id } from "model/ConfigOptionSetConstants";
import { IEntityReferenceValue } from "model/FlexibleAttributeModel";
import { $matt_$fees_and_premiums_$bcbs_attributeset_fee_id } from "model/MasterAttributeConstants";
import { EColumnExtractDataTypes } from "./EColumnExtractDataTypes";
import { IColumnExtract } from "./IColumnExtract.type";
import { IDatasetExtract } from "./IDatasetExtract";
import { IRowExtract } from "./IRowExtract.type";

export default async function EditFeesExcelExtract(state: RootState, dataSource: AppDataSource) {

    // focus out, giving slice for data to commit
    if (document.activeElement)
        //@ts-ignore
        document.activeElement?.blur?.();

    const rows: IRowExtract[] = [];
    const columns: Record<string, IColumnExtract> = {};
    let bccAdminNames: string[] = [];
    let feeTypeNames: string[] = [""];
    let splitOptions: string[] = [];
    let columnIX = 0;

    const attributeFee = state.data.config.cache.map_bcbs_config_attribute[$att_$fees_and_premiums_$bcbs_attributeset_fee_id];

    const createDefaultColumns = () => {
        columns['id'] = {
            attributeId: '',
            order: 0,
            width: 25,
            index: ++columnIX,
            fieldName: 'id',
            hidden: true,
            name: 'ID',
            dataType: EColumnExtractDataTypes.Default,
        };

        // columns['planName'] = {
        //     attributeId: '',
        //     order: 0,
        //     width: 35,
        //     index: ++columnIX,
        //     fieldName: 'planName',
        //     hidden: false,
        //     name: 'Plan',
        //     dataType: EColumnExtractDataTypes.Default,
        // };

        // columns['cesClientNumber'] = {
        //     attributeId: '',
        //     order: 0,
        //     width: 20,
        //     index: ++columnIX,
        //     fieldName: 'cesClientNumber',
        //     hidden: false,
        //     name: 'CES Client Number',
        //     dataType: EColumnExtractDataTypes.Default,
        // };

        columns['feeAndPremiumName'] = {
            attributeId: '',
            order: 0,
            width: 35,
            index: ++columnIX,
            fieldName: 'feeAndPremiumName',
            hidden: false,
            name: 'Fees And Premium',
            dataType: EColumnExtractDataTypes.Default,
        };

        columns['scope'] = {
            attributeId: '',
            order: 0,
            width: 6,
            index: ++columnIX,
            fieldName: 'scope',
            hidden: false,
            name: 'Scope',
            dataType: EColumnExtractDataTypes.Default,
        };

        columns['Status'] = {
            attributeId: '',
            order: 0,
            width: 6,
            index: ++columnIX,
            fieldName: 'status',
            hidden: false,
            name: 'Status',
            dataType: EColumnExtractDataTypes.Default,
        };


        columns['bccAdminCategory'] = {
            attributeId: '',
            order: 50000,
            width: 12,
            index: ++columnIX,
            fieldName: 'bccAdminCategory',
            hidden: false,
            name: 'Category',
            dataType: EColumnExtractDataTypes.Default,
        };
    }

    createDefaultColumns();

    // Building Columns based on configuration
    // should include all columns for fee attribute set
    state.data.config.attributes.forEach(eachAttribute => {

        // https://bcbsonlinedevgl.crm.dynamics.com/main.aspx?appid=bcf569be-d29b-ec11-b400-000d3a5b9435&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=f5646443-d590-ec11-b400-0022480a93ed
        // bcbs_attributeset_fee Fee
        // we are only doing fees attribute
        if (eachAttribute._bcbs_masterattributesetid_value !== $matt_$fees_and_premiums_$bcbs_attributeset_fee_id)
            return;

        // if not part of views, ignore
        if (!eachAttribute.bcbs_viewsortorder)
            return;

        const eachAttributeMaster = state.data.config.cache.map_bcbs_config_masterattribute[eachAttribute._bcbs_config_masterattributeid_value!];

        const controlType = eachAttributeMaster.bcbs_attributetypecode as EControlType;
        //console.log(eachAttributeMaster)
        let columnType = EColumnExtractDataTypes.Default;
        if (controlType === EControlType.currency)
        {
            columnType =  EColumnExtractDataTypes.Currency
        }
        else if (controlType === EControlType.lookup || controlType === EControlType.optionset || controlType === EControlType.boolean){
            columnType = EColumnExtractDataTypes.DropDown
        }
                
        columns[eachAttribute.bcbs_config_attributeid!] = {
            attributeId: eachAttribute.bcbs_config_attributeid!,
            order: eachAttribute.bcbs_viewsortorder ?? 1,
            width: (eachAttribute.bcbs_viewcolumnwidth ?? 250) / 10,
            index: eachAttribute.bcbs_viewsortorder ?? ++columnIX,
            fieldName: eachAttribute.bcbs_config_attributeid!,
            hidden: false,
            name: eachAttribute.bcbs_name!,
            dataType: columnType
        };
    });

    const friendlyValueOption: IFriendlyValueOptions = {
        useDecimalFormatterOnCurrency: true
    };


    for (const key in state.data.config.cache.map_bcbs_bccadmin) {
        if (state.data.config.cache.map_bcbs_bccadmin.hasOwnProperty(key)) {
            const configCat = state.data.config.cache.map_bcbs_bccadmin[key];
            if (configCat.statecode === 0) //active bccadmins
            {
                //console.log(`TESTINGLOG:::::::Key: ${key}, Value:`, configCat);
                bccAdminNames.push(configCat.bcbs_name ?? "")
            }
        }
    }

    
    //console.log("FEE TYPE OPTIONSET VALUES" + JSON.stringify(state.data.config.cache.map_bcbs_config_optionsetitems_bySetId["72381981-d578-ec11-8d21-000d3a35957e"]))
    //iterate through this set - if it matches the snapshot properties add each optionsetitemid to the fee type
    
    var feeTypeOptionSetItems = state.data.config.cache.map_bcbs_config_optionsetitems_bySetId[$oset_$fee_fee_type_id];
    feeTypeOptionSetItems.forEach(optionSetItem => {
        if(optionSetItem.bcbs_fundingtypecode?.includes(state.data.snapshot.bcbs_fundingtypecode?.toString()!) &&
            optionSetItem.bcbs_erisacode?.includes(state.data.json.erisa!.value.toString()!) &&
            optionSetItem.bcbs_grandfatheredcode?.includes(state.data.json.grandFathered!.value.toString()!) )
        {
            feeTypeNames.push(optionSetItem.bcbs_name!)
        }
    })

    var bcbsscSplit = state.data.config.cache.map_bcbs_config_optionsetitems_bySetId[$oset_$fee_split_id];
    bcbsscSplit.forEach(optionSetItem => {
        if(optionSetItem.bcbs_name)
        {
            splitOptions.push(optionSetItem.bcbs_name!)
        }
    })
    
    //let rows: Record<string, string>[] = []
    state.data.json.feesAndPremiums.forEach((eachFeesAndPremium, index) => {
        eachFeesAndPremium.attributeSets.forEach((eachAttributeSet, index) => {
            
            // Pick only FEE attribute set
            if (eachAttributeSet.attributeSetRef.id !== attributeFee._bcbs_config_masterattributeid_value)
                return;
            
            const row: Record<string, string> = {};
            //row.id = eachFeesAndPremium.id;
            row.id = eachAttributeSet.id;
            row.name = eachAttributeSet.name;
            row.feeAndPremiumName = eachFeesAndPremium.name;
            //row.planName = eachPlan.name;
            row.scope = attributeFee.bcbs_label ?? "";
            row.status = "Active";

            // const cesClientNumbers = cesNumberByPlan[eachPlan.id];
            // row.cesClientNumber = cesClientNumbers?.[0] ?? ''
            
            eachAttributeSet.fields.forEach(eachField => {

                const configAttribute = state.data.config.cache.map_bcbs_config_attribute[eachField.configRef.id];
                const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];

                const controlType = masterAttribute.bcbs_attributetypecode as EControlType;

                const field = eachField.values?.[0];

                const config = state.data.config.cache.map_bcbs_config_attribute[eachField.configRef.id];



                if (config.bcbs_config_attributeid === bcbs_config_attributeid_BCCAdmin) {
                    console.log(`adminBCC field ${config.bcbs_config_attributeid}`)
                    // is this field a BCC Admin field?
                    // its used as a criteria to aggregate on for calculations
                    const value = eachField?.values?.[0]?.value as IEntityReferenceValue;

                    if (value) {
                        // lets find the category selected in bcc admin
                        const bccAdmin = state.data.config.cache.map_bcbs_bccadmin[value.id];
                        
                        if (bccAdmin._bcbs_categoryid_value) {
                            const category = state.data.config.cache.map_bcbs_config_category[bccAdmin._bcbs_categoryid_value!];
                            if (category)
                            {
                                row.bccAdminCategory = category.bcbs_name!;
                            }
                        }
                    }
                }


                if (field.value) {
                    let value = friendlyValue(controlType, field.value, friendlyValueOption);

                    const fieldName = configAttribute.bcbs_config_attributeid!;

                    if (!columns[fieldName])
                        return;

                    row[fieldName] = value;
                }

            });


            if (eachAttributeSet.deactivated)
                row.status = "Inactive";

            if (eachFeesAndPremium.deactivated)
                row.status = "Inactive Fees And Premium";

            rows.push(row);
            
        });
    });

    const columnsArray = Object.entries(columns)
        .map(kv => kv[1])
        .sort((w, q) => w.index - q.index);

    // let gcColumnIX = 0;
    // const gcColumns: Record<string, IColumnExtract> = {};
    // gcColumns['name'] = {
    //     attributeId: '',
    //     order: 0,
    //     width: 100,
    //     index: ++gcColumnIX,
    //     fieldName: 'name',
    //     hidden: false,
    //     name: 'Name',
    //     dataType: EColumnExtractDataTypes.Default,
    // };

    // const field_stopLossPending = state.data.config.cache.map_bcbs_config_attribute[bcbs_config_attributeid_Bcbs_StopLossPending];
    // gcColumns[field_stopLossPending.bcbs_config_attributeid!] = {
    //     attributeId: '',
    //     order: 0,
    //     width: 100,
    //     index: ++gcColumnIX,
    //     fieldName: field_stopLossPending.bcbs_config_attributeid!,
    //     hidden: false,
    //     name: field_stopLossPending.bcbs_label!,
    //     dataType: EColumnExtractDataTypes.Default,
    // };

    // const gcColumnsArray = Object.entries(gcColumns)
    //     .map(kv => kv[1])
    //     .sort((w, q) => w.index - q.index);

    // const gcRows: IRowExtract[] = [];

    // const gcRow: Record<string, string> = {};
    // gcRow.name = state.data.snapshot.bcbs_name!;

    // state.data.json.fields.forEach(eachField => {

    //     const configAttribute = state.data.config.cache.map_bcbs_config_attribute[eachField.configRef.id];
    //     const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[configAttribute?._bcbs_config_masterattributeid_value!];

    //     if (!configAttribute || !masterAttribute) {
    //         console.warn(`Missing attribute ${eachField.configRef.name}...`, eachField);
    //         return;
    //     }

    //     const controlType = masterAttribute.bcbs_attributetypecode as EControlType;

    //     const field = eachField.values?.[0];

    //     const config = state.data.config.cache.map_bcbs_config_attribute[eachField.configRef.id];

    //     if (config.bcbs_config_attributeid === field_stopLossPending.bcbs_config_attributeid) {

    //         if (field.value) {
    //             let value = friendlyValue(controlType, field.value, friendlyValueOption);

    //             const fieldName = configAttribute.bcbs_config_attributeid!;

    //             if (!gcColumns[fieldName])
    //                 return;

    //             gcRow[fieldName] = value;
    //         }
    //     }
    // });


    // gcRows.push(gcRow);

    const dataSet: IDatasetExtract = {
        name: '',
        tables: [
            {
                columns: columnsArray,
                data: rows,
                name: "Fees And Premiums"
            }
        ],
        dropDownTables: [
            {
                Id: bcbs_config_attributeid_BCCAdmin,
                Title: 'BCC Admin',
                dropdownOptions:[
                    {options: bccAdminNames, Title: 'BCC Admin'}
                ] 
            },
            {
                Id: bcbs_config_attributeid_FeeType, //NEED TO CHECK THE FUNCDING ERISA AND GRANDFATHER
                Title: 'Fee Type',
                dropdownOptions:[
                    {options: feeTypeNames, Title: 'Fee Type'}
                ]
            },
            {
                Id:bcbs_config_attributeid_Guarantee,
                Title: 'Guarantee',
                dropdownOptions : [
                    {
                        options: ["Yes", "No", ""],
                        Title: 'Guarantee'
                    }
                ]
            },
            {
                Id:bcbs_config_attributeid_BCBSSCOtherSplit,
                Title: 'BCBSSC Other Split',
                dropdownOptions : [
                    {
                        options: splitOptions,
                        Title: 'BCBSSC Other Split'
                    }
                ]
            },
            {
                Id:bcbs_config_attributeid_BillGroup,
                Title: 'Bill Group',
                dropdownOptions : [
                    {
                        options: ["Yes", "No", ""],
                        Title: 'Bill Group'
                    }
                ]
            },
            {
                Id:bcbs_config_attributeid_ShowSeparateOnBill,
                Title: 'Show Separate On Bill',
                dropdownOptions : [
                    {
                        options: ["Yes", "No", ""],
                        Title: 'Show Separate On Bill'
                    }
                ]
            },
            {
                Id:bcbs_config_attributeid_Onsite,
                Title: 'Onsite',
                dropdownOptions : [
                    {
                        options: ["Yes", "No", ""],
                        Title: 'Onsite'
                    }
                ]
            }
        ]
    };

    const test = await dataSource.GenerateEditableExcelExtract(dataSet);
    return test
    
}